module.exports = __webpack_public_path__ + "img/pt3.67fc2622.png";